import NavBar from './src/NavBar';
export default NavBar;